import { render, staticRenderFns } from "./FactoringAvancesProyectosBoletines.vue?vue&type=template&id=b3760666"
import script from "./FactoringAvancesProyectosBoletines.vue?vue&type=script&lang=js"
export * from "./FactoringAvancesProyectosBoletines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports